import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import theme from './theme';
Vue.use(Vuetify);
const themeParam = process.env.VUE_APP_THEME || 'default';
// console.log('xxparam',themeParam);
export default new Vuetify({
	icons: {
		iconfont: 'mdi'
	},
	theme: {
		dark: false,
		themes: theme[themeParam]
	}
});
